<template>
  <div>
    <div class="ibox">
      <div class="ibox-title">
        Item: {{ item.kind }}
      </div>

      <div class="ibox-content">
        <Panel :data="item" />

        <template v-if="item.item_id">
          <hr>
          <small>
            <router-link :to="`/admin/items/${item.item_id}`" target="_blank">Parent ID: {{ item.item_id}}</router-link>
          </small>
        </template>
      </div>
    </div>

    <template v-if="loaded">
      <div class="ibox">
        <div class="ibox-title">
          Events
          <span class="float-right mr-3" style="cursor: pointer" @click="toggleRelation('events')">
            <EyeIcon v-if="mapRelation.events.show" />
            <EyeOffIcon v-else />
          </span>
        </div>

        <div class="ibox-content" v-show="mapRelation.events.show">
          <Events :item="item" v-if="mapRelation.events.loaded" />
        </div>
      </div>

      <div class="ibox">
        <div class="ibox-title">
          Items
          <span class="float-right mr-3" style="cursor: pointer" @click="toggleRelation('items')">
            <EyeIcon v-if="mapRelation.items.show" />
            <EyeOffIcon v-else />
          </span>
        </div>

        <div class="ibox-content" v-show="mapRelation.items.show">
          <Items :item="item" v-if="mapRelation.items.loaded" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ModelMapper from '@/mixins/ModelMapper'
import EntityProxy from '@/models/EntityProxy'
import Panel from '@/components/admin/maestro/Panel'

import Events from './ItemEvents.vue'
import Items from './ItemItems.vue'

import { mapMutations } from 'vuex'
import { EyeIcon, EyeOffIcon } from 'vue-feather-icons'

export default {
  components: { Items, Events, Panel, EyeIcon, EyeOffIcon },
  computed: {
    currentAxios() {
      return this.axios.v3
    },
    item() {
      return EntityProxy.build(this.getModel || {})
    }
  },
  created() {
    if (this.$route.query.kind)
      this.kind = this.$route.query.kind

    this.asyncTemplateShow(this.id, {
      after: () => {
        this.setNameBreadcrumb(this.item.id)
        this.loaded = true
      }
    })
  },
  data: () => ({
    kind: null,
    modelPathPrefix: 'admin',
    nameModel: 'Item',
    loaded: false,
    mapRelation: {
      events: { loaded: false, show: false },
      items: { loaded: false, show: false }
    }
  }),
  methods: {
    ...mapMutations(['setNameBreadcrumb']),
    toggleRelation(name) {
      this.mapRelation[name]['show'] = !this.mapRelation[name]['show']
      if (this.mapRelation[name]['show'])
        this.mapRelation[name]['loaded'] = true
    },
    async asyncShow(id, path, headers) {
      if (this.kind)
        return this.currentAxios.get(`${path}/${id}?kind=${this.kind}`, { headers: headers })
      else
        return this.currentAxios.get(`${path}/${id}`, { headers: headers })
    },
  },
  mixins: [ModelMapper],
  name: 'AdminItemsShow',
  props: {
    id: { required: true },
  }
}
</script>

<style scoped></style>
